import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { marquee as MarqueePropType } from 'lib/CustomPropTypes';

const stripTags = (content) => content.replace(/<[^>]+>/g, '');

class Breaking extends React.Component {
  static propTypes = {
    dismissMarquee: PropTypes.func.isRequired,
    marquee: MarqueePropType.isRequired,
  };

  marqueeContent() {
    const {
      marquee: {
        body: [
          { html: content },
        ] = [],
        item,
      },
    } = this.props;

    // Linked to content.
    if (item && item.url && item.url.primary) {
      return (
        <Link to={item.url.primary} className="breaking-marquee__link">
          {stripTags(content || 'Breaking news')}
          <span className="breaking-marquee__icon icon icon-arrow-link" />
        </Link>
      );
    }

    // Links within text.
    if (content.search(/<a href/) !== -1) {
      /* eslint-disable react/no-danger */
      return (
        <p className="breaking-marquee__link">
          <span dangerouslySetInnerHTML={{ __html: content }} />
          <span className="breaking-marquee__icon icon icon-arrow-link" />
        </p>
      );
      /* eslint-enable react/no-danger */
    }

    // Just text.
    return (
      <p className="breaking-marquee__text">
        {content}
      </p>
    );
  }

  render() {
    const { dismissMarquee } = this.props;

    return (
      <div
        className="breaking-marquee dn-print"
        data-test="marquee-breaking"
      >
        {this.marqueeContent()}
        <button
          type="button"
          aria-label="Close"
          className="breaking-marquee__close-button icon icon-close"
          onClick={dismissMarquee}
        />
      </div>
    );
  }
}

export default Breaking;
